import { render } from "./Step4.vue?vue&type=template&id=3bb0f7d1"
import script from "./Step4.vue?vue&type=script&lang=ts"
export * from "./Step4.vue?vue&type=script&lang=ts"
script.render = render

export default script